import email from "./email.js";
import google from "./google.js";

// 새 제공자(애플·카카오)는 파일 하나를 만들고 여기에 넣으면 끝난다.
// 충돌 처리·토큰 교환·이관은 게이트웨이에 한 벌만 있으므로 손댈 것이 없다.
export const PROVIDERS = Object.fromEntries([email, google].map((p) => [p.id, p]));
